import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import api from "@/lib/api";
import MarketingNav from "@/components/brand/MarketingNav";
import MarketingFooter from "@/components/brand/MarketingFooter";

export default function BlogPreviewPage() {
  const { id } = useParams();
  const [data, setData] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    api.get(`/public/articles/${id}`)
      .then(({ data }) => setData(data))
      .catch(() => setError(true));
  }, [id]);

  if (error) return <div className="dark-marketing min-h-screen flex items-center justify-center text-ivory-200">Article not ready.</div>;
  if (!data) return <div className="dark-marketing min-h-screen flex items-center justify-center text-ivory-200">Loading…</div>;

  return (
    <div className="bg-ivory-50 min-h-screen text-navy-900">
      <MarketingNav />
      <article className="max-w-3xl mx-auto pt-32 pb-24 px-6" data-testid="blog-preview">
        <p className="editorial-overline">Editorial preview</p>
        <h1 className="font-serif text-4xl sm:text-5xl mt-4 leading-tight">{data.title}</h1>
        <p className="text-muted-foreground mt-3">{data.meta_description}</p>
        <div className="gold-divider my-10 opacity-60" />
        <div className="markdown-body text-navy-900">
          <pre className="whitespace-pre-wrap font-sans text-base leading-relaxed">{data.markdown}</pre>
        </div>

        <div className="mt-12 border-l-2 border-gold-500 pl-5">
          <p className="editorial-overline">CTA</p>
          <p className="font-serif text-2xl mt-2">{data.cta_block}</p>
          <Link to="/signup" className="inline-block mt-5 px-6 py-3 bg-navy-900 hover:bg-navy-800 text-ivory-50 font-semibold rounded-sm text-sm">Try TrendRise AI</Link>
        </div>

        <div className="mt-12">
          <p className="editorial-overline">FAQ</p>
          <div className="mt-4 space-y-4">
            {(data.faq || []).map((f) => (
              <div key={f.q} className="border border-border p-5 rounded-sm bg-white">
                <p className="font-serif text-lg">{f.q}</p>
                <p className="text-sm text-muted-foreground mt-2">{f.a}</p>
              </div>
            ))}
          </div>
        </div>
      </article>
      <MarketingFooter />
    </div>
  );
}
